import { useMemo } from 'react'
import { Box, useTheme } from '@mui/material'

const ProgressBar = ({percent, variant = 'primary'}) => {
  const theme = useTheme()
  const bgColor = useMemo(() => {
    return variant === 'primary'
      ? theme.palette.primary.main
      : variant === 'error'
        ? theme.palette.error.main
        : theme.palette.primary.main
  }, [percent, variant])
  return (
    <Box
      sx={{
        width: '100%',
        height: 8,
        backgroundColor: theme.palette.grey[100],
        position: 'relative',
        borderRadius: 4
    }}>
      <Box
        sx={{
          position: 'absolute',
          width: `${percent}%`,
          height: 8,
          backgroundColor: bgColor,
          borderRadius: 4
      }}/>
    </Box>
  )
}

export default ProgressBar